// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { useTranslation } from "react-i18next"; 

// const API_BASE = "https://api.mahal.qa/api";

// const MahalStealDeals = () => {
//   const scrollRef = useRef(null);

//   const [pause, setPause] = useState(false);
//   const [cart, setCart] = useState({});
//   const [deals, setDeals] = useState([]);
//   const [startIndex, setStartIndex] = useState(0);
//   const { t, i18n } = useTranslation();
// const isArabic = i18n.language === "ar";

// const localizeNumber = (value) => {
//   return new Intl.NumberFormat(isArabic ? "ar-QA" : "en-US").format(
//     Number(value || 0)
//   );
// };

// const localizeCurrency = (value) => {
//   return isArabic
//     ? `${localizeNumber(value)} ${t("qar")}`
//     : `${t("qar")} ${localizeNumber(value)}`;
// };

// const getDealTitle = (d) => {
//   if (!d.dealTitle) return t("special_offer");

//   return isArabic
//     ? d.dealTitle
//         .replace("Special", t("special_offer"))
//         .replace("OFF", t("off"))
//         .replace(/\d+/g, (num) => localizeNumber(num))
//     : d.dealTitle;
// };

// const getQty = (qty) => {
//   if (!qty) return "";

//   return isArabic
//     ? qty.replace(/\d+/g, (num) => localizeNumber(num))
//     : qty;
// };

// const getProductName = (d) => {
//   return isArabic ? d.name_ar || d.name : d.name;
// };

// const toArabicNumber = (value) => {
//   return String(value).replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d]);
// };

//   /* ================= FETCH ================= */
//   useEffect(() => {
//     const fetchDeals = async () => {
//       try {
//         const res = await axios.get(`${API_BASE}/gridlist`);

//         const products = res.data.products || [];

//         // ✅ FILTER OFFERS
//         const offers = products.filter(
//           (p) =>
//             p.offer_type &&
//             (
//               p.discount_percentage > 0 ||
//               p.flat_amount > 0 ||
//               p.buy_quantity > 0
//             )
//         );

//         // ✅ MAP TO YOUR OLD UI FORMAT
//         const formatted = offers.map((item) => ({
//           id: item.id, // ✅ product_id already
//           dealTitle: item.label, // same as old UI
//           name_ar: item.name_ar || item.product_name_arabic || item.name,
//           qty: item.unit_of_measure || "",
//           price: item.price_numeric, // new price
//           oldPrice: item.price_numeric, // keep same (or change if needed)
//           img: item.img1, // ✅ IMPORTANT (fix UI)
//         }));

//         setDeals(formatted);

//       } catch (err) {
//         console.error("❌ FETCH ERROR:", err);
//       }
//     };

//     fetchDeals();
//   }, []);

//   /* ================= AUTO ================= */
//   useEffect(() => {
//     if (deals.length === 0) return;

//     const interval = setInterval(() => {
//       if (pause) return;

//       setStartIndex((prev) =>
//         prev + 1 >= deals.length ? 0 : prev + 1
//       );
//     }, 3000);

//     return () => clearInterval(interval);
//   }, [deals, pause]);

//   /* ================= SLICE ================= */
//   let visibleDeals = deals.slice(startIndex, startIndex + 6);

//   if (visibleDeals.length < 6 && deals.length > 0) {
//     visibleDeals = [
//       ...visibleDeals,
//       ...deals.slice(0, 6 - visibleDeals.length),
//     ];
//   }


// /* ================= ADD TO CART ================= */
// const addToCart = async (item) => {

//   try {

//     const token = localStorage.getItem("token");

//     if (!token) {
//       alert(t("login_required"));
//       return;
//     }

//     const res = await axios.post(
//       `${API_BASE}/cart/add`,
//       {
//         product_id: item.id,
//         quantity: 1,
//         price: item.price,
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     // ✅ Already exists in cart
//     if (res.data.status === "exists") {

//  alert(t("product_already_cart"));

//     }

//     // ✅ New product added
//     else {

//       alert(t("added_to_cart"));

//     }

//     console.log("✅ Added");

//   } catch (err) {

//     console.error(
//       "❌ CART ERROR:",
//       err.response?.data
//     );

// alert(err.response?.data?.error || t("error"));

//   }

// };

//   /* ================= CART ================= */
// const addItem = async (item) => {

//   await addToCart(item);

//   setCart((prev) => ({

//     ...prev,

//     [item.id]: (prev[item.id] || 0) + 1,

//   }));

// };

// const removeItem = async (item) => {

//   try {

//     const token = localStorage.getItem("token");

//     if (!token) {
//       alert("Login required");
//       return;
//     }

//     const currentQty = cart[item.id] || 1;

//     const newQty = currentQty - 1;

//     // =====================================
//     // GET USER CART
//     // =====================================

//     const cartRes = await axios.get(
//       `${API_BASE}/cart/me`,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     const cartItem = cartRes.data.items.find(
//       (i) => i.product_id === item.id
//     );

//     if (!cartItem) {
//       return;
//     }

//     // =====================================
//     // REMOVE ITEM COMPLETELY
//     // =====================================

//     if (newQty <= 0) {

//       await axios.delete(
//         `${API_BASE}/cart/remove/${cartItem.cart_item_id}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       setCart((prev) => {

//         const updated = { ...prev };

//         delete updated[item.id];

//         return updated;

//       });

//     }

//     // =====================================
//     // UPDATE QUANTITY
//     // =====================================

//    else {

//   await axios.put(
//     `${API_BASE}/cart/update`,
//     {
//       cart_item_id: cartItem.cart_item_id,
//       quantity: newQty,
//     },
//     {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     }
//   );

//   setCart((prev) => ({
//     ...prev,
//     [item.id]: newQty,
//   }));

// }

//   } catch (err) {

//     console.error(
//       "❌ REMOVE ERROR:",
//       err.response?.data || err
//     );

//     alert(
//       err.response?.data?.error ||
//       "Failed to update cart"
//     );

//   }

// };

//   /* ================= UI ================= */
//   return (
//     <div className="container mt-5" dir={isArabic ? "rtl" : "ltr"}>
//       <h3 className="mm-steal-title">{t("steal_deals_for_you")}</h3>

//       <div
//         className="mm-steal-row"
//         ref={scrollRef}
//         onMouseEnter={() => setPause(true)}
//         onMouseLeave={() => setPause(false)}
//       >
//         {visibleDeals.map((d) => (
//           <div className="mm-deal-card" key={d.id}>
            
//         <div className="mm-deal-title-badge">
//           {getDealTitle(d)}
//         </div>

//             <div className="mm-deal-body">
//               <span className="mm-deal-qty">{getQty(d.qty)}</span>

//               <div className="mm-deal-img">
//                 <img
//                   src={
//                     d.img && d.img.trim() !== ""
//                       ? d.img.startsWith("http")
//                         ? d.img
//                         : `${API_BASE}/${d.img}`
//                       : null
//                   }
//                   alt={getProductName(d)}
//                   onError={(e) => {
//                     console.log("Image failed:", d.img);
//                     e.target.style.display = "none";
//                   }}
//                 />
//               </div>

//               <h4 className="mm-deal-title">{getProductName(d)}</h4>

//               <div className="mm-deal-price">
//                 <div className="mm-deal-price">
//                   <span className="mm-old-price">
//                     {localizeCurrency(d.oldPrice)}
//                   </span>
//                   <span className="mm-new-price">
//                     {localizeCurrency(d.price)}
//                   </span>
//                 </div>
//               </div>

//               {!cart[d.id] ? (
//                 <button
//                   className="mm-add-btn"
//                   onClick={() => addItem(d)}
//                 >
//                  {t("add")}
//                 </button>
//               ) : (
//                 <div className="mm-stepper">
//                   <button onClick={() => removeItem(d)}>-</button>
//                   <span>{localizeNumber(cart[d.id])}</span>
//                   <button onClick={() => addItem(d)}>+</button>
//                 </div>
//               )}
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default MahalStealDeals;


import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { formatPrice, getCurrencySymbol } from "../../utils/currency";

const API_BASE = "https://api.mahal.qa/api";

const parsePrice = (val) => {
  if (!val) return 0;

  return Number(
    String(val).replace(/[^\d.]/g, "")
  ) || 0;
};

const MahalStealDeals = () => {
  const scrollRef = useRef(null);

  const [pause, setPause] = useState(false);
  const [cart, setCart] = useState({});
  const [deals, setDeals] = useState([]);
  const [startIndex, setStartIndex] = useState(0);

  /* ================= FETCH ================= */
  useEffect(() => {
    const fetchDeals = async () => {
      try {
        // const res = await axios.get(`${API_BASE}/top-deals`);

        const res = await axios.get(
          `${API_BASE}/top-deals`,
          {
            timeout: 5000,
          }
        );

        const products = res.data.products || [];

        const formatted = products.map((item) => ({
          id: item.id,

          // dealTitle:
          //   item.offer_label ||
          //   "SPECIAL OFFER",

          dealTitle:
            item.offer_type === "flat"
              ? `${parseFloat(item.flat_amount || 0)} ${getCurrencySymbol(item.currency || "QAR")} OFF`

              : item.offer_type === "percentage"
              ? `${parseFloat(item.discount_percentage || 0)}% OFF`

              : item.offer_type === "bogo"
              ? `BUY ${parseFloat(item.buy_quantity || 0)} GET ${parseFloat(item.get_quantity || 0)}`

              : item.offer_label || "SPECIAL OFFER",

          name: item.name,

          qty:
            item.unit_of_measure || "",

          price:
            Number(
              item.discounted_price ||
              item.price_numeric
            ),

          oldPrice:
            Number(
              item.original_price ||
              item.price_per_unit ||
              item.price_numeric ||
              0
            ),

          currency:
            item.currency || "QAR",

          img: item.img1,

          offer_type: item.offer_type,

          has_offer: item.has_offer,
        }));

        setDeals(formatted);

      } catch (err) {
        console.error("❌ FETCH ERROR:", err);
      }
    };

    fetchDeals();
  }, []);

  /* ================= AUTO ================= */
  useEffect(() => {
    if (deals.length === 0) return;

    const interval = setInterval(() => {
      if (pause) return;

      setStartIndex((prev) =>
        prev + 1 >= deals.length ? 0 : prev + 1
      );
    }, 2500);

    return () => clearInterval(interval);
  }, [deals, pause]);

  // /* ================= SLICE ================= */
  // let visibleDeals = deals.slice(startIndex, startIndex + 6);

  // if (visibleDeals.length < 6 && deals.length > 0) {
  //   visibleDeals = [
  //     ...visibleDeals,
  //     ...deals.slice(0, 6 - visibleDeals.length),
  //   ];
  // }

  const visibleDeals =
    deals.length > 6
      ? [
          ...deals.slice(startIndex, startIndex + 6),
          ...deals.slice(
            0,
            Math.max(0, startIndex + 6 - deals.length)
          ),
        ].slice(0, 6)
      : deals;

  /* ================= ADD TO CART ================= */
  const addToCart = async (item) => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        alert("Login required");
        return;
      }

      await axios.post(
        `${API_BASE}/cart/add`,
        {
          product_id: item.id, // ✅ correct
          quantity: 1,
          price: item.price,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("✅ Added");

    } catch (err) {
      console.error("❌ CART ERROR:", err.response?.data);
      alert(err.response?.data?.error || "Error");
    }
  };

  /* ================= CART ================= */
  const addItem = (item) => {
    addToCart(item);

    setCart((prev) => ({
      ...prev,
      [item.id]: (prev[item.id] || 0) + 1,
    }));
  };

  const removeItem = (item) => {
    setCart((prev) => {
      const updated = { ...prev };
      if (updated[item.id] === 1) delete updated[item.id];
      else updated[item.id] -= 1;
      return updated;
    });
  };

  /* ================= UI ================= */
  return (
    <>
      <style>
        {`
          .mm-deal-card{
            width:230px;
            min-width:230px;

            background:#fff;
            border-radius:16px;

            border:1px solid #ededed;

            // overflow:hidden;
            overflow:visible;
            position:relative;

            transition:0.25s ease;

            padding:12px;

            display:flex;
            flex-direction:column;

            min-height:390px;
            padding-bottom:10px;

            box-shadow:0 2px 8px rgba(0,0,0,0.04);
          }

          .mm-deal-card:hover{
            transform:translateY(-3px);
            box-shadow:0 8px 18px rgba(0,0,0,0.08);
          }

          .mm-deal-title-badge{
            position:absolute;
            top:10px;
            left:10px;

            z-index:5;

            background:linear-gradient(90deg,#ff6b00,#ff8c00);

            color:#fff;

            font-size:12px;
            font-weight:700;

            padding:7px 14px;

            border-radius:8px;

            max-width:120px;

            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
          }

          .mm-deal-body{
            display:flex;
            flex-direction:column;

            align-items:center;

            height:100%;
            width:100%;
          }

          .mm-deal-qty{
            position:absolute;
            top:12px;
            right:12px;

            background:#f3f4f6;

            color:#666;

            font-size:11px;
            font-weight:700;

            padding:4px 8px;

            border-radius:6px;
          }

          .mm-deal-cart{
            width:100%;

            display:flex;

            justify-content:center;

            align-items:center;

            margin-top:12px;
          }

          .mm-deal-img{
            width:100%;
            height:130px;

            display:flex;
            align-items:center;
            justify-content:center;

            margin-top:18px;
            margin-bottom:12px;

            overflow:hidden;
          }

          .mm-deal-img img{
            width:100%;
            height:100%;

            object-fit:contain;

            transition:0.3s ease;
          }

          .mm-deal-card:hover .mm-deal-img img{
            transform:scale(1.06);
          }

          .mm-deal-title{
            font-size:16px;
            font-weight:500;

            line-height:20px;

            text-align:center;

            min-height:44px;

            margin-bottom:6px;

            color:#222;

            display:-webkit-box;
            -webkit-line-clamp:2;
            -webkit-box-orient:vertical;

            overflow:hidden;
          }

          .mm-deal-price{
            display:flex;
            align-items:center;
            justify-content:center;

            gap:6px;

            width:100%;

            min-height:32px;

            margin-top:0px;
            margin-bottom:8px;

            flex-wrap:nowrap;

            visibility:visible !important;
            opacity:1 !important;

            position:relative;
            z-index:3;
          }

          .mm-old-price{
            color:#9ca3af;

            font-size:14px;
            font-weight:500;

            text-decoration:line-through;

            white-space:nowrap;
          }

          .mm-new-price{
            color:#111827;

            font-size:18px;
            font-weight:600;

            white-space:nowrap;

            display:flex;
            align-items:center;
            justify-content:center;

            line-height:1;
          }

          .mm-add-btn{
            width:82%;

            height:42px;

            border:none;

            background:#22c55e;

            color:#fff;

            font-size:15px;
            font-weight:600;

            border-radius:10px;

            transition:0.25s ease;

            margin:0 auto;
            margin-top:4px;
            flex-shrink:0;

            display:flex;
            align-items:center;
            justify-content:center;
          }

          .mm-add-btn:hover{
            background:#16a34a;
            transform:none;
            box-shadow:none;
          }

          .mm-steal-row{
            display:flex;
            gap:16px;

            overflow:visible;
          }

          .mm-stepper{
            width:82%;

            height:42px;

            background:#22c55e;

            border-radius:10px;

            display:flex;
            align-items:center;
            justify-content:center;

            gap:14px;

            margin:0 auto;
            margin-top:auto;
            flex-shrink:0;

            position:relative;

            left:auto;
            right:auto;
            bottom:auto;
            top:auto;

            transform:none;

            overflow:hidden;
          }

          .mm-stepper button{
            width:26px;
            height:26px;

            border:none;

            border-radius:6px;

            background:#fff;

            color:#16a34a;

            font-size:16px;
            font-weight:700;

            display:flex;
            align-items:center;
            justify-content:center;

            cursor:pointer;

            flex-shrink:0;

            padding:0;
          }

          .mm-stepper span{
            color:#fff;

            font-size:16px;
            font-weight:700;

            min-width:18px;

            text-align:center;

            line-height:1;
          }

          @media(max-width:768px){

            .mm-deal-card{
              width:190px;
              min-width:190px;

              min-height:360px;
            }

            .mm-deal-img{
              height:150px;
            }

            .mm-deal-title{
              font-size:17px;
              line-height:24px;
            }

            .mm-new-price{
              font-size:20px;
            }
          }
        `}
      </style>
      
      <div className="container mt-5">
        <h3 className="mm-steal-title">Steal deals for you</h3>

        <div
          className="mm-steal-row"
          ref={scrollRef}
          onMouseEnter={() => setPause(true)}
          onMouseLeave={() => setPause(false)}
        >
          {visibleDeals.map((d) => (
            <div className="mm-deal-card" key={d.id}>
              
              <div className="mm-deal-title-badge">
                {d.dealTitle}
              </div>

              <div className="mm-deal-body">
                {/* <span className="mm-deal-qty">{d.qty}</span> */}
                <span className="mm-deal-qty">{d.qty || "1 Unit"}</span>

                <div className="mm-deal-img">
                  <img
                    loading="lazy"
                    draggable="false"
                    src={
                      d.img && d.img.trim() !== ""
                        ? d.img.startsWith("http")
                          ? d.img
                          : `${API_BASE}/${d.img}`
                        : null
                    }
                    alt={d.name}
                    className="mm-product-img"
                    onError={(e) => {
                      // console.log("Image failed:", d.img);
                      e.target.style.display = "none";
                    }}
                  />
                </div>

                <h4 className="mm-deal-title">{d.name}</h4>
                {/* <div className="mm-product-info">

                  <h4 className="mm-deal-title">
                    {d.name}
                  </h4>

                  <div className="mm-deal-sub">
                    Premium Quality
                  </div>

                </div> */}

                {/* <div className="mm-deal-price">
                  <span className="mm-old-price">
                    QAR {d.oldPrice}
                  </span>
                  <span className="mm-new-price">
                    QAR {d.price}
                  </span>
                </div> */}

                <div className="mm-deal-price">

                <span className="mm-new-price">
                    {formatPrice(d.price, d.currency)}
                  </span>

                  {parseFloat(d.oldPrice || 0) !==
                    parseFloat(d.price || 0) && (
                    <span className="mm-old-price">
                      {formatPrice(d.oldPrice, d.currency)}
                    </span>
                  )}

                </div>

                {!cart[d.id] ? (
                  <button
                    className="mm-add-btn"
                    onClick={() => addItem(d)}
                  >
                    Add
                  </button>
                ) : (
                  <div className="mm-stepper">
                    <button onClick={() => removeItem(d)}>-</button>
                    <span>{cart[d.id]}</span>
                    <button onClick={() => addItem(d)}>+</button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default MahalStealDeals;